import React, { Component } from "react";
import { connect } from 'react-redux';
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";
import { Map } from 'immutable';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Moment from 'react-moment';

import { notificationListActions, getCurrentNotificationList, getNotificationsForCurrentNotificationList } from "../core/notifications-lists";
import {  NotificationViewModal } from "../components/notifications";
import { NOTIFICATIONS_EVENTS_LIST_OPTIONS, DEFAULT_PER_PAGE } from "../core/constants";

import { notificationActions } from "../core/notifications";

const EstatusIcon = ({ row }) => {
  let icon = 'clear'
  let class_name=""
  if ( row.dtLectura ){
    icon = 'envelope-open'
    class_name="text-secondary"
  }
  else{
    icon = 'envelope'
    class_name="text-primary"
  }

  return (
    <div className={ `m-0 p-0 btn ${class_name}` } style={{ fontSize:20 }}> <i className={ `far fa-${icon}` }></i></div>
  )
};

class NotificacionesPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show_popup_detail: false,
      current_item: null
    }

    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }


  componentWillMount() {
      const {  authenticated, user, notificationlist, loadNotifications } = this.props
      if (authenticated && user.sessionId && !notificationlist.isPending)
        loadNotifications('prestador')

  }

  componentDidUpdate(oldProps,oldState){
    const { user,  authenticated, notificationlist, loadNotifications} = this.props
    if ( authenticated &&  oldProps.user.sessionId !== user.sessionId && !notificationlist.isPending ){
      loadNotifications('prestador')
    }
  }

  handleCloseModal () {
    this.setState({
      show_popup_detail: false,
      current_item: null
    });
  }

  handleRowClick(e, row, rowIndex){

    console.log(rowIndex, row)
    this.props.loadNotification(row.id)
    this.setState({
      show_popup_detail: true,
      current_item: row.id
    });
  }


  render() {
    const { show_popup_detail, current_item } = this.state
    const { notificationlist, notifications, navigateToPath } = this.props

    if ( !notificationlist )
      return null;

      const columns = [
          {
            text: 'Estado',
            dataField: 'dtLectura',
            formatter: (cell, row) => <EstatusIcon row={row}/>,
            sort: true,
            headerStyle: () => {
              return { width: "6%" };
            },
            events: {
              onClick: (e, column, columnIndex, row, rowIndex) => {
                e.preventDefault();
                this.handleRowClick(e, row,rowIndex)
                return false;
              }
            }
          },
          {
            text: 'Evento',
            dataField: 'evento',
            sort: true,
            headerStyle: () => {
              return { width: "10%" };
            },
            events: {
              onClick: (e, column, columnIndex, row, rowIndex) => {
                e.preventDefault();
                this.handleRowClick(e, row,rowIndex)
                return false;
              }
            },
            formatExtraData: NOTIFICATIONS_EVENTS_LIST_OPTIONS,
            formatter: (cell, row) => {
              let text = ""
                const event = NOTIFICATIONS_EVENTS_LIST_OPTIONS.find(  event => event.id === row.evento )
                if ( event )
                  text = event.label

              return (
                  <span>
                    { `${text}` }
                  </span>
                )
            },
          },
          {
            text: 'Mensaje',
            dataField: 'mensaje',
            headerStyle: () => {
              return { width: "10%" };
            },
            sort: true,
            events: {
              onClick: (e, column, columnIndex, row, rowIndex) => {
                e.preventDefault();
                this.handleRowClick(e, row,rowIndex)
                return false;
              }
            }
          },

          {
            text: 'Fecha',
            dataField: 'dtCreated',
            formatter: (cell, row ) => {
              return row.dtCreated !== '0001-01-01T00:00:00' ?
               <Moment date={row.dtCreated} format="DD/MM/YYYY H:mm" /> : ''
            },
            sort: true,
            headerStyle: () => {
              return { width: "10%" };
            },
            events: {
              onClick: (e, column, columnIndex, row, rowIndex) => {
                e.preventDefault();
                this.handleRowClick(e, row,rowIndex)
                return false;
              }
            }
          },

        ];

    return(

      <Container fluid className="main-content-container col-12">

        <NotificationViewModal navigateToPath={navigateToPath} show={show_popup_detail}  handleClose={this.handleCloseModal} notificationId={current_item} />

        <ToolkitProvider keyField="id" data={ notifications.toJS()  } columns={ columns } search >
          {
            props => (
              <div>
                <p></p>
                <Row>
                  <Col>
                    <BootstrapTable  {...props.baseProps}
                      wrapperClasses="table-fixed-head"
                      bordered={ false }
                      headerClasses="rdt_TableHead"
                      hover
                      condensed
                      pagination={ paginationFactory({
                        hideSizePerPage:true,
                        sizePerPage: DEFAULT_PER_PAGE
                      }) }
                      rowStyle={ { cursor: 'pointer' } }
                      loading={ true }
                    />
                  </Col>
                </Row>
              </div>
            )
          }
          </ToolkitProvider>
        </Container>

      );
  }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    notificationlist: getCurrentNotificationList(state, props),
    notifications: getNotificationsForCurrentNotificationList(state, props),

  };
};

const mapDispatchToProps = {
  loadNotifications: notificationListActions.loadNotifications,
  loadNotification : notificationActions.loadNotification
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificacionesPage);
